export function formatDateParts(dateStr) {
  if (!dateStr) return { day: '—', month: '', weekday: '' };
  const d = new Date(`${dateStr}T12:00:00`);
  if (Number.isNaN(d.getTime())) return { day: '—', month: '', weekday: '' };
  return {
    day: String(d.getDate()).padStart(2, '0'),
    month: d.toLocaleDateString('en-US', { month: 'short' }),
    weekday: d.toLocaleDateString('en-US', { weekday: 'short' }),
  };
}
